/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

"use client";

import { useEffect } from "react";

const hashRegEx = /^#[a-zA-Z][\w-]*$/;

export const useScrollClientHash = () => {
	useEffect(() => {
		// Scroll to hash fragment after component mounts
		const scrollToHash = (): void => {
			const hash = window.location.hash;
			if (hash && hashRegEx.test(hash)) {
				const element = document.getElementById(hash.substring(1));
				if (element) {
					element.scrollIntoView({ behavior: "smooth" });
				}
			}
		};

		// Use a small delay to ensure DOM is fully rendered
		const timeoutId = setTimeout(scrollToHash, 500);

		return () => clearTimeout(timeoutId);
	}, []);
};
